module.exports = __webpack_public_path__ + "static/media/orange-background.6b4779dd.svg";